import BulletList from '@tiptap/extension-bullet-list'
import Heading from '@tiptap/extension-heading'
import { baseExtensions } from '../extensions/base-extensions'
import { CustomListItemExtension } from '../extensions/custom-list-item-extensions'
import ListItem from '@tiptap/extension-list-item'

export const getExtensions = (
  enableHeadings: boolean,
  isBulletList: boolean,
) => {
  const dependecies = [...baseExtensions]
  if (enableHeadings) {
    dependecies.push(Heading)
  }
  if (isBulletList) {
    dependecies.push(
      BulletList.configure({
        keepMarks: false,
        keepAttributes: false,
      }),
      CustomListItemExtension,
    )
  } else {
    dependecies.push(BulletList, ListItem)
  }

  return dependecies
}
